/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lot_Label_Print_Btn_Disabled_Pending_ApproveInputs */

const vi_lot_label_print_btn_disabled_pending_approve = /** @type {(inputs: Lot_Label_Print_Btn_Disabled_Pending_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chỉ in được sau khi PNK được duyệt`)
};

/**

* @param {Lot_Label_Print_Btn_Disabled_Pending_ApproveInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_label_print_btn_disabled_pending_approve = /** @type {((inputs?: Lot_Label_Print_Btn_Disabled_Pending_ApproveInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_Label_Print_Btn_Disabled_Pending_ApproveInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_label_print_btn_disabled_pending_approve(inputs)
});